import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
export function Seal({
  className = ''
}: {
  className?: string;
}) {
  const {
    brand
  } = useBrand();
  return <svg viewBox="0 0 200 200" className={className} role="img" aria-label={`${brand.name}: ${brand.sealTop.toLowerCase()}, ${brand.sealBottom.toLowerCase()}`} data-id="element-38" data-mp="3emlv9tyrrlme">
      <defs data-id="element-39" data-mp="34svdt9128bg7">
        <path id="seal-arc-top" d="M 100 100 m -78 0 a 78 78 0 1 1 156 0" fill="none" data-id="element-40" data-mp="2qv6p1q3vgk5v" />
        <path id="seal-arc-bottom" d="M 100 100 m 74 0 a 74 74 0 1 1 -148 0" fill="none" data-id="element-41" data-mp="2qxjhwyb64exp" />
      </defs>
      <circle cx="100" cy="100" r="96" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" data-id="element-42" data-mp="2vrx6ohvbrnte" />
      <circle cx="100" cy="100" r="62" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" data-id="element-43" data-mp="2lw3w341624e9" />
      <text fontSize="14" letterSpacing="4" fill="currentColor" fontFamily="var(--font-body)" data-id="element-44" data-mp="f5mgtl0jfsqa">
        <textPath href="#seal-arc-top" startOffset="50%" textAnchor="middle" data-id="element-45" data-mp="k4qq0bngpqgm">
          {brand.sealTop}
        </textPath>
      </text>
      <text fontSize="14" letterSpacing="4" fill="currentColor" fontFamily="var(--font-body)" data-id="element-46" data-mp="3bcbv9oxv0rhc">
        <textPath href="#seal-arc-bottom" startOffset="50%" textAnchor="middle" data-id="element-47" data-mp="36f270cm7ilv3">
          {brand.sealBottom}
        </textPath>
      </text>
      <text x="100" y="128" textAnchor="middle" fontSize="76" fill="currentColor" fontFamily="var(--font-display)" data-id="element-48" data-mp="3l59iu9hpl6mt">
        {brand.monogram}
      </text>
    </svg>;
}